import React, { useState } from "react";
import { Box, Paper, Typography, List, ListItem, ListItemIcon, ListItemText, Avatar } from "@mui/material";

const Legend: React.FC = () => {
  const [hovered, setHovered] = useState(false);

  const statuses = [
    { status: "Started", meaning: "Comparison started, processing in progress", color: "#1976d2" },
    { status: "Compared", meaning: "Comparison completed, waiting for approval", color: "#9c27b0" },
    { status: "Approval Pending", meaning: "Awaiting approval before migration", color: "#ff9800" },
    { status: "Completed", meaning: "Migration finished successfully", color: "#4caf50" },
    { status: "Failed", meaning: "Migration or comparison failed", color: "#f44336" },
  ];

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Paper
        elevation={4}
        sx={{
          borderRadius: hovered ? 2 : "50%",
          width: hovered ? 280 : 50,
          height: hovered ? "auto" : 50,
          transition: "all 0.3s ease-in-out",
          cursor: "pointer",
          p: hovered ? 2 : 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {hovered ? (
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Legend
            </Typography>
            <List dense>
              {statuses.map((item, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <Avatar sx={{ bgcolor: item.color, width: 20, height: 20 }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.status}
                    secondary={item.meaning}
                    primaryTypographyProps={{ fontWeight: "bold" }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        ) : (
          <Avatar sx={{ bgcolor: "#1976d2", width: 40, height: 40, fontSize: 12 }}>
            info
          </Avatar>
        )}
      </Paper>
    </Box>
  );
};

export default Legend;
